<!--
Merk at mat-optgroup ikke kan nøstes, dvs vi kan ikke representere gruppe og plan vhja mat-optgroup.
Dersom mat-select kun inneholder mat-optgroup vil disse ikke vises, derfor bruker vi her kun mat-option til å
representere gruppe/plan og håndtere innrykk for å visualisere struktur manuelt vhja css
 -->
<mat-select [formControl]="skjemakontroll()"
            [compareWith]="erValgt"
            [placeholder]="placeholder()"
            [multiple]="multiple()"
            hideSingleSelectionIndicator="false"
            panelClass="velg-moeter-alternativer"
            data-testid="moetevelger"
            panelWidth="300"
            #moetevelger>
  <mat-select-trigger>
    @switch (valgteMoeter().length) {
      @case (0) {
        {{ 'Ingen valgt'|translate }}
      }
      @case (1) {
        <div class="møte">
          <div>{{ valgteMoeter()[0].tittel }} {{ valgteMoeter()[0].nummer }} ({{ valgteMoeter()[0].dato.start | zoneddatetime }})</div>
          <div class="gruppe">{{ gruppe(valgteMoeter()[0].eiendeGruppeId).gruppetittel }}</div>
        </div>
      }
      @default {
        {{ '{antall} møter valgt i {grupper} grupper'|translate:{antall: valgteMoeter().length, grupper: antallValgteGrupper()} }}
      }
    }
    <!--@if(skjemakontroll().value != null) {
      @for(moete of skjemakontroll().value; track moete.id){
        <div class="møte">
        <div >{{ moete.tittel }} {{ moete.nummer }} ({{ moete.dato.start | zoneddatetime }})</div>
        <div class="gruppe">{{gruppe(moete.eiendeGruppeId)?.gruppetittel }}</div>
        </div>
      }
     } @else {
      INGEN
    }-->
  </mat-select-trigger>
  <!-- lister grupper -->
  @for (gruppe of grupper(); track gruppe.gruppe.id) {
    <mat-option (click.stopp)="gruppe.ekspanderEllerKolaps($event, moetevelger)"
                [attr.aria-expanded]="gruppe.ekspandert()"
                [attr.aria-label]="'Åpne eller lukk {gruppe} '|translate: {gruppe: gruppe.gruppetittel}"
                class="gruppe">
      <button mat-icon-button type="button" class="ekspander-eller-kolaps">
        <mat-icon>{{ gruppe.ekspandert() ? 'expand_more' : 'chevron_right' }}</mat-icon>
      </button>
      <span>{{ gruppe.gruppetittel }}</span>
    </mat-option>
    @if (gruppe.ekspandert()) {
      @if (gruppe.laster()) {
        <ng-container *ngTemplateOutlet="lasterFragment; context: {klasse: 'plan'}"/>
      } @else {
        @if (gruppe.harHistoriskePlaner() && !gruppe.viserHistoriskePlaner()) {
          <div (click)="gruppe.visHistoriskePlaner(moetevelger)" class="vis-avsluttede-periode">
            {{ 'Vis {antall} avsluttede planperioder'|translate:{antall: gruppe.historiskePlaner().length} }}
          </div>
        } @else if (gruppe.harHistoriskePlaner()) {
          <div (click)="gruppe.viserHistoriskePlaner.set(false)" class="vis-avsluttede-periode">
            {{ 'Skjul {antall} avsluttede planperioder'|translate:{antall: gruppe.historiskePlaner().length} }}
          </div>
        }
        <!-- lister planer -->
        @for (plan of gruppe.barn(); track plan.plan.id) {
          @if (!plan.erHistorisk || gruppe.viserHistoriskePlaner()) {
            <mat-option (click.stopp)="plan.ekspanderEllerKolaps($event, moetevelger)"
                        [attr.aria-expanded]="plan.ekspandert()"
                        [attr.aria-label]="'Åpne eller lukk plan for {plan} '|translate:{plan:plan.formatertPeriode}"
                        class="plan">
              <button mat-icon-button type="button" class="ekspander-eller-kolaps">
                <mat-icon>{{ plan.ekspandert() ? 'expand_more' : 'chevron_right' }}</mat-icon>
              </button>
              <span>{{ 'Plan for {periode}'|translate: {periode: plan.formatertPeriode} }}</span>
            </mat-option>
            @if (plan.ekspandert()) {
              @if (plan.laster()) {
                <ng-container *ngTemplateOutlet="lasterFragment; context: {klasse: 'møte'}"/>
              } @else {
                @if (plan.harAvholdteMoeter() && !plan.viserAvholdteMoeter()) {
                  <div (click)="plan.visAvholdteMoeter(moetevelger)" class="vis-avholdte-møter" data-testid="vis-avholdte-møter">
                    {{ 'Vis {antall} avholdte møter'|translate:{antall: plan.avholdteMoeter().length} }}
                  </div>
                } @else if (plan.harAvholdteMoeter()) {
                  <div (click)="plan.viserAvholdteMoeter.set(false)" class="vis-avholdte-møter" data-testid="skjul-avholdte-møter">
                    {{ 'Skjul {antall} avholdte møter'|translate:{antall: plan.avholdteMoeter().length} }}
                  </div>
                }
                <!-- lister møter -->
                @for (moete of plan.barn(); track moete.moete.id) {
                  @if (!moete.erAvholdt || plan.viserAvholdteMoeter()) {
                    <mat-option [value]="moete.moete" [disabled]="!moete.tilgjengelig" class="møte" [matTooltip]="moeteTooltip(moete)" matTooltipPosition="right">
                      {{ moete.moete.tittel }} {{ moete.moete.nummer }} ({{ moete.moete.dato.start | zoneddatetime }})
                      @if (!moete.tilgjengelig) {
                        <div class="møte-ikke-valgbart-årsak">{{ moeteTooltip(moete) }}</div>
                      }
                    </mat-option>
                  }
                }
                @if (plan.barn().length === 0) {
                  <mat-option disabled class="møte">{{ 'Ingen møter'|translate }}</mat-option>
                }
              }
            }
          }
        }
        @if (gruppe.barn().length === 0) {
          <mat-option disabled class="plan">{{ 'Ingen planer'|translate }}</mat-option>
        }
      }
    }

  }
</mat-select>

<ng-template #lasterFragment let-klasse="klasse">
  <mat-option disabled class="laster" [ngClass]="klasse">
    <mat-progress-spinner mode="indeterminate" diameter="20"/>
    <span>{{ 'Laster...'|translate }}</span>
  </mat-option>
</ng-template>
